import { jsxs, jsx } from "react/jsx-runtime";
const IconPenSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M13.8 2.733c-.933-.933-2.667-.933-3.6 0l-7.333 7.334c-.067.066-.134.2-.2.333L2 13.733c-.067.2 0 .467.2.6.133.134.267.2.467.2H2.8l3.333-.666a.367.367 0 0 0 .334-.2L13.8 6.333c1-1 1-2.6 0-3.6ZM5.667 12.6l-2.134.4.4-2.133 5.734-5.734L11.4 6.867 5.667 12.6Zm7.2-7.2-.534.533L10.6 4.2l.533-.533a1.248 1.248 0 0 1 1.734 0 1.248 1.248 0 0 1 0 1.733Z" })
    ]
  }
);
export {
  IconPenSvg
};
